import React from 'react';
import './style.scss';
import CardsServices from 'src/views/SoftwareEngineering/components/CardsServices';
import { cardDataPredictiveAnalytics } from 'src/shared/utils/string';
import FooterServices from 'src/views/SoftwareEngineering/components/FooterServices';
import Footer from 'src/components/footer';
import BreadcrumbAiMl from '../Breadcrumb';
import { Link } from 'react-router-dom';

const PredictiveAnalytics = () => {
  return (
    <div className="page-container-predictive-analytics">
        <div className='image-container'>
          <div className='text-container drop-in-2'>
          <h1 className='heading drop-in'>Predictive Analytics & Forecasting</h1>
          </div>
            <Link to="/predictive-analytics" className='no-decoration '><BreadcrumbAiMl text={'Predictive Analytics & Forecasting'} /></Link>
            <div className='red-bg-box'></div>
        </div>

        <CardsServices cardDataServices={cardDataPredictiveAnalytics} />
        <FooterServices />
        <Footer />
    </div>
  )
}

export default PredictiveAnalytics